import Axios from "axios"

export const retrieveData = async (configObj = { url: '', headers: {}, method: '', payload: {} }) => {
    try {
        formatConfigObj(configObj)
        const res = await Axios(configObj)
        return res.data
    } catch (err) {
        throw new Error(err)
    }
}

const getKey = (method = '') => {
    if(method.toUpperCase() === 'GET') return 'params'
    if(method.toUpperCase() === 'POST') return 'data'

    throw new Error('wrong method')
}

const formatConfigObj = (configObj = {}) => {
    const { payload, method } = configObj

    const newKey = getKey(method)
    configObj[newKey] = payload
    delete configObj.payload
}